<div class="merge-success-dialog">
  <div class="success-icon">
    <img src="images/success.svg" alt="Success" />
  </div>

  <!-- <div class="logo">
    <img src="images/ai-kosh-logo.svg" alt="AIKosh" />
  </div> -->

  <h2 class="title">You're all set, {{ data.name }}</h2>
  <p class="subtitle">
    Your AIKosh account is now linked to Jan Parichay. All future logins will
    use Jan Parichay.
  </p>

  <div class="account-card">
    <h4 class="card-title">Your Account</h4>

    @if (data.email) {
      <div class="account-item text-sm">
        <img src="images/email-black.svg" alt="Email" class="item-icon" />
        <span>{{ data.email }}</span>
      </div>
    }

    @if (data.phone) {
      <div class="account-item text-sm">
        <img src="images/Call.svg" alt="Phone" class="item-icon" />
        <span>{{ data.phone }}</span>
      </div>
    }

    <div class="account-item text-green fw-700 text-sm">
      <img src="images/verified-shield.svg" alt="Linked" class="item-icon" />
      <span>Linked via {{ data.provider || "Jan Parichay" }}</span>
    </div>
  </div>

  <button class="btn-dashboard" (click)="onGoToDashboard()">
    Go to Aikosh Dashboard
  </button>
</div>
